<div class="otp-code-flow">
  <form (ngSubmit)="validateOtp($event)" [formGroup]="validateOtpForm">
    <div class="padding-mobile-left-right mb-3">
      <div class="col-12">
        <div class="subheading_instruction">
          <adp-label labelKey="Signup_Create_Account_OTP_Body_Text"></adp-label>
          <p class="fw-600 mb-0 p-email">{{maskedEmail}}</p>
          <adp-label labelKey="Signup_Create_Account_OTP_Expire_Text"></adp-label>
        </div>
      </div>
    </div>
    <div class="otp-form">
      <adp-input class="w-100" formControlName="otpControl" pghNumber pgh-autofocus [inputId]="'Signup_Create_Account_OTP_Field'"
        [resourceData]="resourceService.getResourceObject('Signup_Create_Account_OTP_Field')"></adp-input>
      <mat-error *ngIf="otpError" class="otp-error">{{otpError}}</mat-error>
      <div class="form-group" [ngClass]="{'mt-4': !!otpError, 'mt-2': !otpError}">
        <button mat-flat-button class="next-btn" color="accent" type="submit" [disabled]="!validateOtpForm.valid || reminingAttempt<1">
          <adp-label labelKey="Signup_NewContract_OTPVerifyButton_Text"></adp-label>
        </button>
        <div *ngIf="!isTimerVisible" class="resend-otp">
          <adp-label labelKey="Signup_Create_Account_VerifyOTP_Resend_Text"></adp-label>
          <a href="javascript:void(0)" (click)="resendOTP()" gtmClick="Resend">Resend</a>
        </div>
      </div>
      <div *ngIf="isTimerVisible && timerDisplay" class="resend-otp">
        <adp-label labelKey="Signup_Create_Account_OTP_Timer_Text"></adp-label>
        <span style="font-weight:bold;">{{timerDisplay}}</span>
      </div>
    </div>
  </form>
</div>
